import { historyActions } from '../reducers/history';

export const createHistory = (data) => {
  return (dispatch) => {
    dispatch(historyActions.setHistory(data));
  };
};

export const clearHistory = () => {
  return (dispatch) => {
    dispatch(historyActions.clearHistory());
  };
};
